__turbopack_context__.v({
  "dot": "LifePulse-module__46M9lG__dot",
  "filter": "LifePulse-module__46M9lG__filter",
  "filterOff": "LifePulse-module__46M9lG__filterOff" + " " + "LifePulse-module__46M9lG__filter",
  "filters": "LifePulse-module__46M9lG__filters",
});
